import React, { useState, useEffect, useCallback } from 'react';

// Importações do Firebase - Essenciais para a comunicação com o backend
import { initializeApp } from 'firebase/app';
import { 
    getAuth, 
    onAuthStateChanged, 
    signInWithEmailAndPassword, 
    signOut
} from 'firebase/auth';
import { 
    getFirestore, 
    doc, 
    setDoc, 
    getDoc, 
    collection, 
    onSnapshot,
    addDoc,
    updateDoc,
    increment,
    serverTimestamp,
    query,
    deleteDoc,
    getDocs
} from 'firebase/firestore';

// --- CONFIGURAÇÃO DO FIREBASE ---
const firebaseConfig = {
  apiKey: "AIzaSyA-2v82bdBuRPAZ5UC3Qu2-wZfUp25A22c",
  authDomain: "vieiraalves-f81cc.firebaseapp.com",
  projectId: "vieiraalves-f81cc",
  storageBucket: "vieiraalves-f81cc.firebasestorage.app",
  messagingSenderId: "533245807270",
  appId: "1:533245807270:web:2516b26da1b1357d848267",
  measurementId: "G-2ZWTSD52TK"
};

// Inicializa o Firebase e exporta os serviços para uso na aplicação
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// --- CÓDIGO DA PÁGINA INICIAL ---
// Este é o HTML que será exibido na rota principal ("/")
const homePageHtml = `
<!DOCTYPE html>
<html lang="pt-BR" class="scroll-smooth">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Vieira Alves Advocacia | Especialistas em Direito Bancário</title>

    <!-- SEO + Meta Tags -->
    <meta name="description" content="Vieira Alves Advocacia: Especialistas em direito bancário. Defendemos você contra juros abusivos, cobranças indevidas em cartões de crédito, empréstimos consignados (RMC) e mais.">
    <meta name="keywords" content="direito bancário, advocacia bancária, juros abusivos, RMC, cartão de crédito, empréstimo consignado, cheque especial, vieira alves">
    <meta name="author" content="Vieira Alves Advocacia">
    <link rel="canonical" href="https://www.vieraalves.com.br/">
    <link rel="icon" href="https://i.ibb.co/xq14jkFG/logo-vieira-alves-advogados.png" type="image/png">

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" content="https://www.vieraalves.com.br/">
    <meta property="og:title" content="Vieira Alves Advocacia | Especialistas em Direito Bancário">
    <meta property="og:description" content="Lutamos contra juros abusivos e práticas bancárias indevidas. Proteja seus direitos com nossa assessoria especializada.">
    <meta property="og:image" content="https://placehold.co/1200x630/1A202C/FFFFFF?text=Vieira+Alves+Advocacia+Bancária">

    <!-- Twitter -->
    <meta property="twitter:card" content="summary_large_image">
    <meta property="twitter:url" content="https://www.vieraalves.com.br/">
    <meta property="twitter:title" content="Vieira Alves Advocacia | Especialistas em Direito Bancário">
    <meta property="twitter:description" content="Lutamos contra juros abusivos e práticas bancárias indevidas. Proteja seus direitos com nossa assessoria especializada.">
    <meta property="twitter:image" content="https://placehold.co/1200x630/1A202C/FFFFFF?text=Vieira+Alves+Advocacia+Bancária">

    <!-- Fonts -->
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;700&family=Nunito+Sans:wght@400;600;700&display=swap" rel="stylesheet">
    
    <!-- Libraries -->
    <script src="https://cdn.tailwindcss.com"></script>
    <script src="https://unpkg.com/animejs@3.2.1/lib/anime.min.js"></script>
    <!-- Using Flickity for carousel -->
    <link rel="stylesheet" href="https://unpkg.com/flickity@2/dist/flickity.min.css">
    <script src="https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js"></script>

    <script>
        tailwind.config = {
            theme: {
                extend: {
                    colors: {
                        'brand-dark': '#1A202C',
                        'brand-dark-accent': '#2D3748',
                        'brand-light': '#F7FAFC',
                        'brand-teal': '#0FB5A0',
                        'brand-gold': '#D69E2E',
                    },
                    fontFamily: {
                        'sans': ['Nunito Sans', 'sans-serif'],
                        'serif': ['Merriweather', 'serif'],
                    }
                }
            }
        }
    </script>
    
    <style>
        .flickity-button {
            background: rgba(255, 255, 255, 0.1);
            color: white;
        }
        .flickity-button:hover {
            background: #D69E2E;
        }
        .flickity-page-dots .dot {
            background: rgba(255, 255, 255, 0.5);
        }
        .flickity-page-dots .dot.is-selected {
            background: #D69E2E;
        }
        .reduce-motion .motion-element { 
            transition: none !important; 
            animation: none !important; 
        }
        /* Estilo do cabeçalho fixo ao rolar a página */
        #header.sticky {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            z-index: 50;
            background-color: rgba(255, 255, 255, 0.3); /* Fundo branco com 30% de opacidade */
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px); /* Suporte para Safari */
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            transform: translateY(0);
        }

        /* Cor do texto do menu no cabeçalho fixo */
        #header.sticky #main-nav a {
            color: #1A202C; /* Cor preta/brand-dark */
        }
        
        /* Cor do ícone do menu mobile no cabeçalho fixo */
        #header.sticky #mobile-menu-btn svg {
            color: #1A202C; /* Cor preta/brand-dark */
        }

        /* Cor do texto do menu no hover quando o cabeçalho é fixo */
        #header.sticky #main-nav a:hover {
            color: #D69E2E; /* Cor dourada/brand-gold */
        }
        
        /* REGRAS PARA ANIMAÇÃO DA LOGO */
        #header-logo {
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
        }
        #header.sticky #header-logo {
            opacity: 1;
        }
        #hero-logo {
            transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
            transform-origin: center;
        }
        body.scrolled #hero-logo {
            transform: scale(0.25) translateY(-200%);
            opacity: 0;
        }
    </style>
</head>
<body class="bg-brand-light text-brand-dark-accent antialiased font-sans">

    <a href="#main-content" class="sr-only focus:not-sr-only focus:absolute z-50 top-4 left-4 bg-white p-3 rounded-lg shadow-md">Pular para o conteúdo principal</a>

    <!-- Header -->
    <header id="header" class="absolute w-full top-0 left-0 z-50 py-3 transition-all duration-300">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
            <a href="#">
                <img id="header-logo" src="https://i.ibb.co/xq14jkFG/logo-vieira-alves-advogados.png" alt="Logotipo Vieira Alves Advocacia" class="h-14">
            </a>
            <nav id="main-nav" class="hidden md:flex items-center space-x-8">
                <a href="#servicos" class="text-brand-dark-accent hover:text-brand-gold transition-colors">Serviços</a>
                <a href="#diferencial" class="text-brand-dark-accent hover:text-brand-gold transition-colors">Nosso Diferencial</a>
                <a href="#sobre" class="text-brand-dark-accent hover:text-brand-gold transition-colors">Sobre Nós</a>
                <a href="#contato" class="text-brand-dark-accent hover:text-brand-gold transition-colors">Contato</a>
            </nav>
            <a href="#contato" onclick="window.parent.gtag('event', 'conversion', {'send_to': 'AW-17510670342/lFRcCMW3q5QbEIbA3p1B'});" class="hidden md:inline-block bg-brand-gold text-brand-dark font-bold py-2 px-6 rounded-md hover:opacity-90 transition-opacity">Fale Conosco</a>
            <button class="md:hidden" id="mobile-menu-btn" aria-label="Abrir menu">
                <svg class="h-6 w-6 text-brand-dark-accent transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7" /></svg>
            </button>
        </div>
        <!-- Mobile Menu -->
        <div id="mobile-menu" class="hidden md:hidden bg-white/95 backdrop-blur-sm mt-2 mx-4 rounded-lg shadow-lg">
             <div class="px-4 pt-4 pb-3 space-y-2">
                 <a href="#servicos" class="block text-brand-dark-accent hover:text-brand-gold py-2">Serviços</a>
                 <a href="#diferencial" class="block text-brand-dark-accent hover:text-brand-gold py-2">Nosso Diferencial</a>
                 <a href="#sobre" class="block text-brand-dark-accent hover:text-brand-gold py-2">Sobre Nós</a>
                 <a href="#contato" class="block text-brand-dark-accent hover:text-brand-gold py-2">Contato</a>
                 <a href="#contato" onclick="window.parent.gtag('event', 'conversion', {'send_to': 'AW-17510670342/lFRcCMW3q5QbEIbA3p1B'});" class="block bg-brand-gold text-brand-dark text-center font-bold py-3 px-6 rounded-md hover:bg-opacity-90 transition-colors mt-4">Fale Conosco</a>
            </div>
        </div>
    </header>

    <main id="main-content">
        <!-- Hero Section -->
        <section class="bg-brand-light text-brand-dark pt-32 pb-32">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-16 items-center">
                <div class="text-center md:text-left motion-element">
                    <h1 class="text-4xl lg:text-5xl font-serif font-light leading-tight text-brand-dark">Defesa Estratégica em <span class="font-bold text-brand-gold">Direito Bancário</span>.</h1>
                    <p class="mt-6 text-lg text-gray-600 max-w-xl mx-auto md:mx-0">Lutamos por você contra juros abusivos, cobranças indevidas e contratos desleais. Recupere o controle da sua vida financeira com nossa expertise.</p>
                    <div class="mt-10 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                        <a href="#contato" onclick="window.parent.gtag('event', 'conversion', {'send_to': 'AW-17510670342/lFRcCMW3q5QbEIbA3p1B'});" class="bg-brand-teal text-white font-bold py-3 px-8 rounded-md text-lg hover:opacity-90 transition-opacity">Agende sua Análise</a>
                        <a href="#servicos" class="border border-brand-dark-accent text-brand-dark-accent font-bold py-3 px-8 rounded-md text-lg hover:bg-gray-200 transition-colors">Conheça Nossos Serviços</a>
                    </div>
                </div>
                <div class="flex justify-center items-center h-80 md:h-96 motion-element">
                    <img id="hero-logo" src="https://i.ibb.co/xq14jkFG/logo-vieira-alves-advogados.png" alt="Logotipo Vieira Alves Advocacia em destaque" class="h-72">
                </div>
            </div>
        </section>

        <!-- Services Section -->
        <section id="servicos" class="py-24 sm:py-32 bg-white">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-16 motion-element">
                    <h2 class="text-3xl sm:text-4xl font-serif font-bold text-brand-dark">Nossa Atuação em Direito Bancário</h2>
                    <p class="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">Oferecemos análise completa e soluções personalizadas para uma vasta gama de questões bancárias, protegendo seus direitos e seu patrimônio.</p>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                            <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Direito Bancário Geral</h3>
                            <p class="mt-1 text-gray-600">Defesa completa em todas as áreas do direito bancário.</p>
                        </div>
                    </div>
                    <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                           <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Cartão de Crédito</h3>
                            <p class="mt-1 text-gray-600">Revisão de faturas, juros abusivos e anuidades indevidas.</p>
                        </div>
                    </div>
                    <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                         <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                           <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Cheque Especial</h3>
                            <p class="mt-1 text-gray-600">Análise de juros e renegociação de saldos devedores.</p>
                        </div>
                    </div>
                     <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                         <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                            <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.826-1.106-2.257 0-3.083C10.547 7.219 11.275 7 12 7c.768 0 1.536.219 2.121.659.95.712 2.368.712 3.318 0l.88-.66M12 6V4.5m0 15V19.5" /></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Empréstimos e Financiamentos</h3>
                            <p class="mt-1 text-gray-600">Revisão de contratos, taxas de juros e cláusulas abusivas.</p>
                        </div>
                    </div>
                    <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                           <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Crédito Consignado e RMC</h3>
                            <p class="mt-1 text-gray-600">Cancelamento de empréstimos e cartões não solicitados (RMC).</p>
                        </div>
                    </div>
                    <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                         <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                           <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Capital de Giro</h3>
                            <p class="mt-1 text-gray-600">Assessoria para empresas na obtenção e renegociação de crédito.</p>
                        </div>
                    </div>
                     <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                           <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" ><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.286Z" /></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Seguros</h3>
                            <p class="mt-1 text-gray-600">Análise de apólices e defesa contra negativas de cobertura.</p>
                        </div>
                    </div>
                     <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                            <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" /></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Conta Garantida</h3>
                            <p class="mt-1 text-gray-600">Orientação sobre o uso e renegociação de limites de crédito.</p>
                        </div>
                    </div>
                     <!-- Service Card -->
                    <div class="motion-element bg-brand-light p-6 rounded-lg shadow-sm flex items-start space-x-4">
                        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-brand-gold/10 rounded-full">
                           <svg class="w-6 h-6 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3v11.25" /></svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-serif font-bold text-brand-dark">Descontos Bancários</h3>
                            <p class="mt-1 text-gray-600">Análise de operações de antecipação de recebíveis.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Differential Section -->
        <section id="diferencial" class="py-24 sm:py-32 bg-brand-dark-accent text-white">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                 <div class="text-center mb-16 motion-element">
                    <h2 class="text-3xl sm:text-4xl font-serif font-bold">Nosso Diferencial</h2>
                    <p class="mt-4 text-lg text-gray-400 max-w-3xl mx-auto">Não somos apenas advogados. Somos parceiros estratégicos dedicados a resolver seu problema.</p>
                </div>
                <div class="grid md:grid-cols-3 gap-12 text-center">
                    <div class="motion-element">
                        <div class="flex justify-center items-center h-16 w-16 mx-auto bg-brand-dark rounded-full">
                           <svg class="w-8 h-8 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
                        </div>
                        <h3 class="mt-6 text-xl font-semibold">Abordagem Estratégica</h3>
                        <p class="mt-2 text-gray-400">Analisamos cada detalhe do seu caso para encontrar a solução mais eficiente e vantajosa para você.</p>
                    </div>
                     <div class="motion-element">
                        <div class="flex justify-center items-center h-16 w-16 mx-auto bg-brand-dark rounded-full">
                           <svg class="w-8 h-8 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                        </div>
                        <h3 class="mt-6 text-xl font-semibold">Atendimento Humanizado</h3>
                        <p class="mt-2 text-gray-400">Entendemos a angústia por trás dos problemas bancários e oferecemos um atendimento próximo e empático.</p>
                    </div>
                     <div class="motion-element">
                        <div class="flex justify-center items-center h-16 w-16 mx-auto bg-brand-dark rounded-full">
                           <svg class="w-8 h-8 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.471A9 9 0 112.382 12 9 9 0 0116.618 7.529z"></path></svg>
                        </div>
                        <h3 class="mt-6 text-xl font-semibold">Foco em Resultados</h3>
                        <p class="mt-2 text-gray-400">Nosso compromisso é com a entrega de resultados concretos que protejam seus interesses e seu patrimônio.</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Testimonials -->
        <section id="testimonials" class="py-24 sm:py-32 bg-brand-light">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                 <div class="text-center mb-16 motion-element">
                    <h2 class="text-3xl sm:text-4xl font-serif font-bold">O Que Nossos Clientes Dizem</h2>
                </div>
                <div class="main-carousel" data-flickity='{ "cellAlign": "left", "contain": true, "wrapAround": true, "autoPlay": 6000, "prevNextButtons": false }'>
                    <div class="w-full md:w-3/4 lg:w-2/3 mr-8">
                        <div class="bg-white p-8 rounded-lg shadow-md">
                            <p class="text-gray-600 italic">"Eu estava perdido com a dívida do cartão de crédito e os juros abusivos. A Vieira Alves Advocacia não só reduziu minha dívida drasticamente, como me explicou cada passo do processo. Transparência e resultado incríveis."</p>
                            <p class="mt-6 font-bold text-right">- J. Silva, Cliente de Revisão Contratual</p>
                        </div>
                    </div>
                    <div class="w-full md:w-3/4 lg:w-2/3 mr-8">
                         <div class="bg-white p-8 rounded-lg shadow-md">
                            <p class="text-gray-600 italic">"Descobri um desconto de RMC no meu benefício que eu nunca solicitei. A equipe foi extremamente atenciosa e conseguiu cancelar o contrato e reaver os valores descontados indevidamente. Recomendo a todos os aposentados."</p>
                            <p class="mt-6 font-bold text-right">- M. Costa, Aposentada</p>
                        </div>
                    </div>
                     <div class="w-full md:w-3/4 lg:w-2/3 mr-8">
                         <div class="bg-white p-8 rounded-lg shadow-md">
                            <p class="text-gray-600 italic">"Precisávamos de capital de giro e o banco nos impôs condições desvantajosas. Com a assessoria da Dra. Priscila, conseguimos renegociar o contrato para termos condições justas que permitiram nosso negócio crescer."</p>
                            <p class="mt-6 font-bold text-right">- F. Martins, Empresário</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Team Section -->
        <section id="sobre" class="py-24 sm:py-32 bg-white">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 class="text-3xl sm:text-4xl font-serif font-bold text-brand-dark motion-element">Quem Luta Pelos Seus Direitos</h2>
                <p class="mt-4 text-lg text-gray-600 max-w-3xl mx-auto motion-element">Conheça a advogada especialista que está à frente de cada caso.</p>
                <div class="mt-16 flex justify-center">
                    <div class="motion-element max-w-md">
                        <img class="w-full h-auto object-cover rounded-lg shadow-lg" src="https://media.licdn.com/dms/image/v2/D4D03AQGnUwCGC1kwRQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1681398371803?e=1759363200&v=beta&t=MFsSMR3WMGRykLZUqxAukK1GwE_nt8dvlbQnXV4lQ14" alt="Retrato da advogada Priscila Vieira" onerror="this.onerror=null;this.src='https://placehold.co/400x400/D69E2E/FFFFFF?text=PV';">
                        <h3 class="mt-6 text-2xl font-serif font-bold">Priscila Vieira</h3>
                        <p class="text-brand-gold font-semibold">Sócia Fundadora</p>
                        <div class="mt-4 text-left text-gray-600 space-y-4">
                             <div>
                                <h4 class="font-bold">Escola de Magistratura do Distrito Federal (2020)</h4>
                                <ul class="list-disc list-inside ml-4 text-sm">
                                    <li>Pós-graduação Lato Sensu - Especialização em Direito Civil e Processual Civil.</li>
                                </ul>
                             </div>
                             <div>
                                <h4 class="font-bold">Unyleya (2017)</h4>
                                <ul class="list-disc list-inside ml-4 text-sm">
                                    <li>Pós-graduação Lato Sensu - Especialização em Direito Tributário.</li>
                                </ul>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Contact Section -->
        <section id="contato" class="bg-brand-dark text-white py-24 sm:py-32">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
                 <div class="motion-element">
                    <h2 class="text-3xl sm:text-4xl font-serif font-bold">Analise seu caso sem compromisso</h2>
                    <p class="mt-4 text-lg text-gray-400">Suspeita de cobranças indevidas ou juros abusivos? Preencha o formulário abaixo para uma análise preliminar gratuita. Nossa equipe entrará em contato em breve.</p>
                    <div class="mt-8 space-y-4 text-gray-300">
                        <p class="flex items-center"><svg class="w-5 h-5 mr-3 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>Comércio Quadra 502, Bloco C, loja 37, parte 1877, Via W3 Sul - Asa Sul, Brasília - DF, 70330-530</p>
                        <p class="flex items-center"><svg class="w-5 h-5 mr-3 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>contato@vieiraalves.com.br</p>
                    </div>
                </div>
                <div class="motion-element">
                     <form id="lead-form" class="space-y-4 bg-brand-dark-accent p-8 rounded-lg">
                        <h3 class="font-bold text-xl text-white mb-4">Envie sua mensagem</h3>
                        <div>
                            <label for="name" class="sr-only">Nome</label>
                            <input type="text" name="name" required class="w-full p-3 rounded-md bg-brand-dark text-white border border-gray-600 focus:ring-brand-gold focus:border-brand-gold" placeholder="Nome Completo">
                        </div>
                        <div>
                             <label for="whatsapp" class="sr-only">WhatsApp</label>
                            <input type="tel" name="whatsapp" required class="w-full p-3 rounded-md bg-brand-dark text-white border border-gray-600 focus:ring-brand-gold focus:border-brand-gold" placeholder="Seu WhatsApp com DDD">
                        </div>
                         <div>
                             <label for="message" class="sr-only">Mensagem</label>
                            <textarea name="message" rows="5" required class="w-full p-3 rounded-md bg-brand-dark text-white border border-gray-600 focus:ring-brand-gold focus:border-brand-gold" placeholder="Conte-nos brevemente sobre seu caso..."></textarea>
                        </div>
                         <button type="submit" class="w-full bg-brand-gold text-brand-dark font-bold py-3 px-6 rounded-md hover:opacity-90 transition-opacity">Enviar para Análise</button>
                    </form>
                     <div id="success-message" class="hidden mt-4 text-center bg-green-100 text-green-800 p-4 rounded-lg">
                        <h4 class="font-bold">Mensagem Enviada!</h4>
                        <p class="text-sm">Agradecemos o seu contato. Retornaremos em breve.</p>
                    </div>
                </div>
            </div>
        </section>
    </main>

    <!-- Footer -->
    <footer class="bg-brand-dark text-gray-400">
        <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 text-center">
            <a href="#">
                 <img src="https://i.ibb.co/xq14jkFG/logo-vieira-alves-advogados.png" alt="Logotipo Vieira Alves Advocacia" class="h-14 mx-auto">
            </a>
            <nav class="flex justify-center items-center space-x-6 mt-6">
                <a href="#servicos" class="hover:text-brand-gold transition-colors">Serviços</a>
                <a href="#diferencial" class="hover:text-brand-gold transition-colors">Nosso Diferencial</a>
                <a href="#sobre" class="hover:text-brand-gold transition-colors">Sobre Nós</a>
                <a href="#contato" class="hover:text-brand-gold transition-colors">Contato</a>
            </nav>
            <div class="mt-8 pt-8 border-t border-gray-800 text-sm">
                <p>&copy; 2024 Vieira Alves Advocacia. Todos os Direitos Reservados.</p>
                <p class="mt-2 space-x-4"><a href="#" class="hover:underline">Política de Privacidade</a><span>&middot;</span><a href="#" class="hover:underline">Termos de Serviço</a></p>
                 <button id="motion-toggle" class="mt-4 text-xs hover:underline">Reduzir Animação</button>
            </div>
        </div>
    </footer>

    <!-- Botão Fixo do WhatsApp -->
    <a href="https://wa.me/556195670765" onclick="window.parent.gtag('event', 'conversion', {'send_to': 'AW-17510670342/lFRcCMW3q5QbEIbA3p1B'});" target="_blank" class="whatsapp-button fixed bottom-6 right-6 bg-green-500 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors z-40" aria-label="Fale conosco pelo WhatsApp">
        <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.61 15.35 3.48 16.82L2 22l5.32-1.48C8.73 21.31 10.34 21.8 12.04 21.8h0c5.46 0 9.91-4.45 9.91-9.89c0-5.46-4.45-9.89-9.91-9.89zM17.46 15.58c-.28-.14-1.67-.82-1.93-.92c-.26-.09-.45-.14-0.64.14c-.19.28-.73.92-.89 1.11c-.16.19-.32.22-.59.07c-.28-.14-1.18-.44-2.24-1.38c-.83-.73-1.39-1.64-1.55-1.93c-.16-.28-.02-.44.13-.57c.13-.12.28-.31.42-.46c.14-.15.19-.26.28-.43c.09-.17.05-.31-.02-.45c-.07-.14-.64-1.54-.87-2.09c-.23-.55-.47-.48-.64-.48h-.5c-.17 0-.45.07-.68.31c-.23.25-.88.86-1.08 2.09c-.2.1.23-1.22.48 2.4c.24 1.18.9 2.37 1.02 2.52c.12.15 1.77 2.76 4.34 3.82c2.57 1.06 2.57.71 3.03.68c.46-.03 1.67-.68 1.9-1.32c.23-.64.23-1.18.16-1.32c-.07-.14-.26-.22-.54-.37z"/></svg>
    </a>
    
    <script>
    document.addEventListener('DOMContentLoaded', () => {

        const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        let reduceMotion = motionQuery.matches;

        const header = document.getElementById('header');
        const body = document.body;
        const mobileMenuBtn = document.getElementById('mobile-menu-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const motionToggle = document.getElementById('motion-toggle');
        const motionElements = document.querySelectorAll('.motion-element');

        // Sticky Header & Logo Animation
        const handleScroll = () => {
            if (window.scrollY > 20) {
                header.classList.add('sticky');
                body.classList.add('scrolled');
            } else {
                header.classList.remove('sticky');
                body.classList.remove('scrolled');
            }
        };

        // Mobile Menu Toggle
        const toggleMobileMenu = () => {
            mobileMenu.classList.toggle('hidden');
        };

        // Smooth Scroll Logic
        const handleLinkClick = (e) => {
            e.preventDefault();
            const targetId = e.currentTarget.getAttribute('href');

            if (targetId === '#') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                const targetElement = document.querySelector(targetId);
                if (targetElement) {
                    const headerHeight = header.offsetHeight;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
                    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }

            // Close mobile menu if it's open
            if (!mobileMenu.classList.contains('hidden')) {
                mobileMenu.classList.add('hidden');
            }
        };

        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
             // Exclude the accessibility link
            if (anchor.getAttribute('href') !== '#main-content') {
                anchor.addEventListener('click', handleLinkClick);
            }
        });
        
        // Animate on Scroll
        const animateOnScroll = () => {
            if (reduceMotion) {
                 motionElements.forEach(el => {
                    el.style.opacity = '1';
                });
                return;
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.style.opacity = '1';
                        entry.target.style.transform = 'translateY(0)';
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.1 });

            motionElements.forEach(el => {
                el.style.opacity = '0';
                el.style.transform = 'translateY(20px)';
                el.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
                observer.observe(el);
            });
        };

        // Reduced Motion Toggle
        const toggleMotion = () => {
            reduceMotion = !reduceMotion;
            document.body.classList.toggle('reduce-motion', reduceMotion);
            motionToggle.textContent = reduceMotion ? 'Ativar Animação' : 'Reduzir Animação';
            // Re-initialize animations based on new preference
            initMotion(); 
        };
        
        const initMotion = () => {
            document.body.classList.toggle('reduce-motion', reduceMotion);
            motionToggle.textContent = reduceMotion ? 'Ativar Animação' : 'Reduzir Animação';
            
            // Kill all existing anime instances to prevent doubling up
            if (typeof anime !== 'undefined' && anime.running) {
                anime.running.forEach(anim => anim.pause());
            }

            animateOnScroll();
        };

        // Event Listeners
        window.addEventListener('scroll', handleScroll);
        mobileMenuBtn.addEventListener('click', toggleMobileMenu);
        motionToggle.addEventListener('click', toggleMotion);
        motionQuery.addEventListener('change', (e) => {
            reduceMotion = e.matches;
            initMotion();
        });
        
        // Initializations
        initMotion();

    });
    </script>
</body>
</html>
`;

// --- DADOS DE EXEMPLO ---
// Código HTML de exemplo para popular o banco de dados se ele estiver vazio.
const sampleHtmlContent = `
<!DOCTYPE html>
<html lang="pt-BR">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script src="https://cdn.tailwindcss.com"></script>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet">
    <script src="https://cdn.lordicon.com/lordicon.js"></script>
    <title>Guia Completo BPC/LOAS - Vieira Alves Advocacia</title>
    <style>
        body { font-family: 'Inter', sans-serif; scroll-behavior: smooth; }
        .faq-question { cursor: pointer; }
        .faq-answer { max-height: 0; overflow: hidden; transition: max-height 0.5s ease-in-out; }
        .faq-item.open .faq-answer { max-height: 300px; }
        .faq-item.open .faq-arrow { transform: rotate(180deg); }
        .faq-arrow { transition: transform 0.3s ease; }
    </style>
</head>
<body class="bg-slate-50 text-slate-800">
    <header class="bg-white/90 backdrop-blur-lg sticky top-0 z-40 shadow-md">
        <div class="container mx-auto px-6 py-4 flex justify-between items-center">
            <h1 class="text-xl md:text-2xl font-bold text-purple-900">Vieira Alves Advocacia</h1>
            <a href="#form-section" class="hidden sm:inline-block bg-purple-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-purple-700 transition-all">
                Receber Guia BPC/LOAS
            </a>
        </div>
    </header>
    <main class="relative overflow-hidden">
        <div class="container mx-auto px-6 pt-16 pb-20 md:pt-24 md:pb-28">
            <div class="grid md:grid-cols-2 gap-12 items-center">
                <div>
                    <span class="inline-block bg-purple-200 text-purple-800 text-sm font-semibold px-3 py-1 rounded-full mb-4">GUIA COMPLETO E ATUALIZADO</span>
                    <h2 class="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 leading-tight">
                        Entenda o BPC/LOAS e saiba se você tem direito.
                    </h2>
                    <p class="mt-6 text-lg md:text-xl text-slate-600 max-w-lg mx-auto md:mx-0">Muitos brasileiros podem receber um salário mínimo mensal do governo e não sabem. Nosso guia gratuito explica tudo.</p>
                    <div class="mt-8">
                        <a href="#form-section" class="bg-purple-600 text-white text-lg font-bold px-8 py-4 rounded-lg shadow-xl hover:bg-purple-700 transition-all">
                            BAIXAR MEU GUIA
                        </a>
                    </div>
                </div>
                <div id="form-section">
                    <div class="bg-white p-8 rounded-2xl shadow-2xl border border-slate-200 z-10 relative">
                        <h3 class="text-2xl font-bold text-center text-slate-900">Receba o Guia no seu WhatsApp</h3>
                        <p class="text-center text-slate-500 mt-2 text-sm">Preencha os dados para receber o material gratuito.</p>
                        <form id="lead-form" class="mt-6 space-y-5">
                            <div>
                                <label for="name" class="text-sm font-semibold text-slate-700">Seu Nome Completo</label>
                                <input type="text" id="name" name="name" class="w-full mt-1 p-3 border border-slate-300 rounded-lg" placeholder="Seu nome aqui" required>
                            </div>
                            <div>
                                <label for="whatsapp" class="text-sm font-semibold text-slate-700">Seu WhatsApp com DDD</label>
                                <input type="tel" id="whatsapp" name="whatsapp" class="w-full mt-1 p-3 border border-slate-300 rounded-lg" placeholder="(11) 99999-9999" required>
                            </div>
                            <button type="submit" id="submit-button" class="w-full bg-green-600 text-white text-lg font-bold py-4 rounded-lg shadow-lg hover:bg-green-700">
                                QUERO RECEBER O GUIA
                            </button>
                        </form>
                        <div id="success-message" class="hidden mt-4 text-center bg-green-100 text-green-800 p-4 rounded-lg">
                            <h4 class="font-bold">Guia a caminho!</h4>
                            <p class="text-sm">Verifique seu WhatsApp. A mensagem chegará em instantes.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <footer class="bg-slate-900 text-white">
        <div class="container mx-auto px-6 py-12 text-center">
            <h2 class="text-2xl font-bold">Vieira Alves Advocacia</h2>
            <p class="mt-6 text-sm text-slate-500">&copy; 2024 Vieira Alves Advocacia. Todos os direitos reservados.</p>
        </div>
    </footer>
    <!-- Botão Fixo do WhatsApp -->
    <a href="https://wa.me/5511999999999?text=Quero%20saber%20mais%20sobre%20o%20guia" target="_blank" class="whatsapp-button fixed bottom-5 left-5 z-50 bg-green-500 text-white p-4 rounded-full shadow-xl">
        <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20"><path d="M16.51 3.49C14.71 1.69 12.45 1 10 1 5.03 1 1 5.03 1 10c0 1.63.44 3.16 1.24 4.49L1 20l5.51-1.46c1.28.73 2.75 1.16 4.29 1.16h.01c4.97 0 9-4.03 9-9 0-2.45-.9-4.71-2.7-6.51zm-1.12 11.12c-.27.15-1.59.78-1.84.88-.25.09-.43.14-.62.14-.19 0-.48-.07-.73-.32-.25-.25-.98-1-1.87-1.89-.89-.89-1.52-1.56-1.77-1.81-.25-.25-.04-.38.11-.52.13-.13.27-.32.42-.48.15-.16.2-.25.3-.42.1-.17.05-.31-.02-.43-.08-.12-.62-1.47-.85-2.02-.23-.55-.46-.48-.62-.48-.15 0-.32-.02-.48-.02s-.42.07-.63.32c-.22.25-.85.83-1.09 2.02-.24 1.19.88 2.32 1 2.47.12.15 1.76 2.67 4.25 3.73.59.26 1.05.41 1.41.52.59.18 1.13.15 1.56.09.48-.07 1.59-.65 1.81-1.29.22-.64.22-1.19.15-1.29-.07-.1-.25-.15-.52-.3z"/></svg>
    </a>
</body>
</html>
`;


// --- COMPONENTES DA APLICAÇÃO ---

/**
 * Componente: Tela de Login
 * Responsabilidade: Autenticar o administrador.
 */
const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
            // O onAuthStateChanged no App cuidará do redirecionamento
        } catch (err) {
            setError('Falha no login. Verifique seu e-mail e senha.');
            console.error("Erro de login:", err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="p-8 bg-white rounded-lg shadow-md w-full max-w-md">
                <h1 className="text-2xl font-bold text-center text-purple-900 mb-2">Vieira Alves Advocacia</h1>
                <h2 className="text-xl font-semibold text-center text-gray-700 mb-6">Acesso ao Painel</h2>
                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2" htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded"
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 mb-2" htmlFor="password">Senha</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded"
                            required
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm text-center mb-4">{error}</p>}
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-purple-600 text-white p-3 rounded-lg font-semibold hover:bg-purple-700 disabled:bg-purple-300"
                    >
                        {isLoading ? 'Entrando...' : 'Entrar'}
                    </button>
                </form>
            </div>
        </div>
    );
};

/**
 * Componente: Painel de Administração
 * Responsabilidade: Gerenciar LPs, ver métricas e configurar integrações.
 */
const AdminPanel = ({ onLogout }) => {
    const [pages, setPages] = useState([]);
    const [settings, setSettings] = useState({ facebookPixelId: '', webhookUrl: '' });
    const [currentPage, setCurrentPage] = useState('dashboard');
    const [editingPage, setEditingPage] = useState(null);
    const [textFilter, setTextFilter] = useState('');
    const [productFilter, setProductFilter] = useState('');
    const [dateFilter, setDateFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');

    useEffect(() => {
        const q = query(collection(db, "landingPages"));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const pagesData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                tags: doc.data().name.toLowerCase().includes('ebook') ? 'ebook,marketing,leads' : 'verao,promocao,geral',
                product: doc.data().name.toLowerCase().includes('ebook') ? 'ebook-mkt' : 'colecao-verao',
                status: (doc.data().views || 0) > 100 ? 'Publicada' : 'Rascunho'
            }));
            setPages(pagesData);
        }, (error) => {
            console.error("Erro ao carregar páginas:", error);
            alert("Não tem permissão para ver as páginas. Verifique as regras do Firebase.");
        });
        return unsubscribe;
    }, []);

    useEffect(() => {
        const settingsRef = doc(db, "settings", "integrations");
        const unsubscribe = onSnapshot(settingsRef, (doc) => {
            if (doc.exists()) setSettings(doc.data());
        });
        return unsubscribe;
    }, []);

    useEffect(() => {
        if (currentPage === 'dashboard' && window.lucide) {
            window.lucide.createIcons();
        }
    }, [currentPage, pages, textFilter, productFilter, dateFilter, statusFilter]);

    const handleSaveSettings = async (e) => {
        e.preventDefault();
        const { facebookPixelId, webhookUrl } = e.target.elements;
        const newSettings = {
            facebookPixelId: facebookPixelId.value,
            webhookUrl: webhookUrl.value
        };
        try {
            await setDoc(doc(db, "settings", "integrations"), newSettings);
            alert('Configurações guardadas com sucesso!');
            setCurrentPage('dashboard');
        } catch (error) {
            console.error("Erro ao guardar configurações:", error);
            alert('Erro ao guardar configurações.');
        }
    };

    const handleSavePage = async (e) => {
        e.preventDefault();
        const { name, slug, htmlContent } = e.target.elements;
        const pageData = {
            name: name.value,
            htmlContent: htmlContent.value,
            views: editingPage?.views || 0,
            formSubmissions: editingPage?.formSubmissions || 0,
            whatsappClicks: editingPage?.whatsappClicks || 0,
            createdAt: editingPage?.createdAt || serverTimestamp(),
            lastUpdatedAt: serverTimestamp()
        };
        try {
            await setDoc(doc(db, "landingPages", slug.value), pageData, { merge: true });
            alert(`Página "${name.value}" guardada com sucesso!`);
            setCurrentPage('dashboard');
            setEditingPage(null);
        } catch (error) {
            console.error("Erro ao guardar página:", error);
            alert('Erro ao guardar página.');
        }
    };

    const handleEditClick = (page) => {
        setEditingPage(page);
        setCurrentPage('edit');
    };

    const handleDeletePage = async (pageId, pageName) => {
        if (window.confirm(`Tem a certeza de que deseja excluir a página "${pageName}"?`)) {
            try {
                await deleteDoc(doc(db, "landingPages", pageId));
                alert(`Página "${pageName}" excluída com sucesso!`);
            } catch (error) {
                console.error("Erro ao excluir página:", error);
                alert('Erro ao excluir a página.');
            }
        }
    };

    const clearFilters = () => {
        setTextFilter('');
        setProductFilter('');
        setDateFilter('');
        setStatusFilter('');
    };

    const filteredPages = pages.filter(page => {
        const textMatch = !textFilter || page.name.toLowerCase().includes(textFilter.toLowerCase()) || page.tags.toLowerCase().includes(textFilter.toLowerCase());
        const productMatch = !productFilter || page.product === productFilter;
        const statusMatch = !statusFilter || page.status === statusFilter;
        const dateMatch = !dateFilter || (page.createdAt?.toDate && new Date(page.createdAt.toDate()) >= new Date(dateFilter));
        return textMatch && productMatch && statusMatch && dateMatch;
    });

    const renderContent = () => {
        switch (currentPage) {
            case 'new':
            case 'edit':
                return (
                    <div>
                        <h2 className="text-2xl font-bold mb-4 text-white">{currentPage === 'new' ? 'Nova Landing Page' : 'Editar Landing Page'}</h2>
                        <form onSubmit={handleSavePage} className="space-y-4 bg-gray-800 p-6 rounded-lg shadow">
                            <div>
                                <label className="block font-semibold text-gray-300">Nome da Página</label>
                                <input name="name" type="text" defaultValue={editingPage?.name} required className="w-full p-2 border rounded bg-gray-700 border-gray-600 text-white mt-1" />
                            </div>
                            <div>
                                <label className="block font-semibold text-gray-300">URL Amigável (slug)</label>
                                <input name="slug" type="text" defaultValue={editingPage?.id} required disabled={!!editingPage} className="w-full p-2 border rounded disabled:bg-gray-600 bg-gray-700 border-gray-600 text-white mt-1" placeholder="ex: guia-bpc-loas" />
                                <p className="text-sm text-gray-400 mt-1">A URL será: seudominio.com/<b>slug</b>. Não pode ser alterada depois de criada.</p>
                            </div>
                            <div>
                                <label className="block font-semibold text-gray-300">Código HTML Completo</label>
                                <textarea name="htmlContent" defaultValue={editingPage?.htmlContent ?? sampleHtmlContent} required rows="15" className="w-full p-2 border rounded font-mono text-sm bg-gray-700 border-gray-600 text-white mt-1"></textarea>
                            </div>
                            <div className="flex gap-4">
                               <button type="submit" className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700">Guardar Página</button>
                               <button type="button" onClick={() => { setCurrentPage('dashboard'); setEditingPage(null); }} className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-500">Cancelar</button>
                            </div>
                        </form>
                    </div>
                );
            case 'settings':
                return (
                    <div>
                        <h2 className="text-2xl font-bold mb-4 text-white">Configurações de Integração</h2>
                        <form onSubmit={handleSaveSettings} className="space-y-4 bg-gray-800 p-6 rounded-lg shadow">
                           <div>
                                <label className="block font-semibold text-gray-300">ID do Pixel do Facebook</label>
                                <input name="facebookPixelId" type="text" defaultValue={settings.facebookPixelId} className="w-full p-2 border rounded bg-gray-700 border-gray-600 text-white mt-1" placeholder="123456789012345" />
                           </div>
                           <div>
                                <label className="block font-semibold text-gray-300">URL do Webhook (n8n, etc)</label>
                                <input name="webhookUrl" type="text" defaultValue={settings.webhookUrl} className="w-full p-2 border rounded bg-gray-700 border-gray-600 text-white mt-1" placeholder="https://seu.n8n.url/webhook/..." />
                           </div>
                           <div className="flex gap-4">
                               <button type="submit" className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700">Guardar Configurações</button>
                               <button type="button" onClick={() => setCurrentPage('dashboard')} className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-500">Cancelar</button>
                           </div>
                        </form>
                    </div>
                );
            case 'dashboard':
            default:
                return (
                    <>
                        <section className="bg-gray-800 p-4 rounded-lg mb-8">
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
                                <div>
                                    <label htmlFor="filter-text" className="block text-sm font-medium text-gray-300 mb-1">Procurar</label>
                                    <input type="text" id="filter-text" placeholder="Título ou Tag..." value={textFilter} onChange={e => setTextFilter(e.target.value)} className="w-full bg-gray-700 border-gray-600 text-gray-300 rounded-lg p-2" />
                                </div>
                                <div>
                                    <label htmlFor="filter-product" className="block text-sm font-medium text-gray-300 mb-1">Produto</label>
                                    <select id="filter-product" value={productFilter} onChange={e => setProductFilter(e.target.value)} className="w-full bg-gray-700 border-gray-600 text-gray-300 rounded-lg p-2">
                                        <option value="">Todos</option>
                                        <option value="colecao-verao">Coleção de Verão</option>
                                        <option value="ebook-mkt">Ebook Marketing</option>
                                    </select>
                                </div>
                                 <div>
                                    <label htmlFor="filter-status" className="block text-sm font-medium text-gray-300 mb-1">Status</label>
                                    <select id="filter-status" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full bg-gray-700 border-gray-600 text-gray-300 rounded-lg p-2">
                                        <option value="">Todos</option>
                                        <option value="Publicada">Publicada</option>
                                        <option value="Rascunho">Rascunho</option>
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="filter-date" className="block text-sm font-medium text-gray-300 mb-1">Criada Após</label>
                                    <input type="date" id="filter-date" value={dateFilter} onChange={e => setDateFilter(e.target.value)} className="w-full bg-gray-700 border-gray-600 text-gray-300 rounded-lg p-2" />
                                </div>
                                <div>
                                    <button onClick={clearFilters} className="flex items-center justify-center bg-gray-600 hover:bg-gray-500 text-white font-semibold py-2 px-4 rounded-lg w-full">
                                        <i data-lucide="rotate-cw" className="w-5 h-5 mr-2"></i>
                                        Limpar
                                    </button>
                                </div>
                            </div>
                        </section>
                        <main id="lp-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                            {filteredPages.length > 0 ? filteredPages.map(page => {
                                const conversionRate = page.views > 0 ? ((page.formSubmissions || 0) / page.views * 100).toFixed(2) : '0.00';
                                const statusClass = page.status === 'Publicada' ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400';
                                return (
                                <div key={page.id} className="lp-card bg-gray-800 rounded-xl overflow-hidden shadow-lg flex flex-col">
                                    <img src={`https://placehold.co/600x400/${Math.floor(Math.random()*16777215).toString(16)}/ffffff?text=${encodeURIComponent(page.name)}`} alt={`Preview da ${page.name}`} className="w-full h-40 object-cover"/>
                                    <div className="p-5 flex flex-col flex-grow text-white">
                                        <div className="flex justify-between items-start mb-3">
                                            <h2 className="text-xl font-bold text-white flex-1 pr-2">{page.name}</h2>
                                            <span className={`${statusClass} text-xs font-semibold px-2.5 py-1 rounded-full`}>{page.status}</span>
                                        </div>
                                        <p className="text-gray-400 text-sm mb-4">
                                            Criada: {page.createdAt?.toDate().toLocaleDateString('pt-BR') || 'N/A'}
                                        </p>
                                        <div className="grid grid-cols-3 gap-4 text-center mb-5">
                                            <div><p className="text-2xl font-bold">{page.views || 0}</p><p className="text-xs text-gray-400">Visitas</p></div>
                                            <div><p className="text-2xl font-bold">{page.formSubmissions || 0}</p><p className="text-xs text-gray-400">Leads</p></div>
                                            <div><p className="text-2xl font-bold text-indigo-400">{conversionRate}%</p><p className="text-xs text-gray-400">Conv.</p></div>
                                        </div>
                                        <div className="mt-auto border-t border-gray-700 pt-4 flex justify-around">
                                            <button onClick={() => handleEditClick(page)} className="text-gray-400 hover:text-white" title="Editar"><i data-lucide="edit" className="w-5 h-5"></i></button>
                                            <a href={`/${page.id}`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" title="Visualizar"><i data-lucide="eye" className="w-5 h-5"></i></a>
                                            <button className="text-gray-400 hover:text-white" title="Analytics (Em breve)"><i data-lucide="bar-chart-2" className="w-5 h-5"></i></button>
                                            <button onClick={() => handleDeletePage(page.id, page.name)} className="text-red-500 hover:text-red-400" title="Excluir"><i data-lucide="trash-2" className="w-5 h-5"></i></button>
                                        </div>
                                    </div>
                                </div>
                            )}) : (
                                <div className="col-span-full text-center py-12 bg-gray-800 rounded-lg">
                                    <h3 className="text-xl font-semibold text-white">Nenhuma landing page encontrada</h3>
                                    <p className="text-gray-400 mt-2">Tente ajustar os seus filtros ou crie uma nova página.</p>
                                </div>
                            )}
                        </main>
                    </>
                );
        }
    };

    return (
        <div className="min-h-screen bg-gray-900 text-gray-200" style={{fontFamily: "'Inter', sans-serif"}}>
            <header className="bg-gray-800 shadow-md">
                <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                    <h1 onClick={() => setCurrentPage('dashboard')} className="text-xl font-bold text-white cursor-pointer">Painel de Controle</h1>
                    <div>
                        <button onClick={() => { setEditingPage(null); setCurrentPage('new'); }} className="font-semibold text-white bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-lg mr-4">
                           + Criar Nova Página
                        </button>
                        <button onClick={() => setCurrentPage('settings')} className="font-semibold text-gray-300 mr-6 hover:text-white">Configurações</button>
                        <button onClick={onLogout} className="font-semibold text-red-400 hover:text-red-300">Sair</button>
                    </div>
                </div>
            </header>
            <main className="container mx-auto px-6 py-8">
                {renderContent()}
            </main>
        </div>
    );
};


/**
 * Componente: Renderizador de Página Pública
 * Responsabilidade: Exibir o HTML da LP e injetar os scripts de tracking.
 */
const PublicPageRenderer = ({ htmlContent, pageSlug }) => {
    const [pageWithScripts, setPageWithScripts] = useState('');
    const [error, setError] = useState(null);

    const trackFormSubmission = useCallback(async (formData) => {
        try {
            await addDoc(collection(db, "leads"), {
                ...formData,
                landingPageId: pageSlug,
                submittedAt: serverTimestamp()
            });
            const pageRef = doc(db, "landingPages", pageSlug);
            await updateDoc(pageRef, { formSubmissions: increment(1) });
        } catch (err) {
            console.error("Erro ao rastrear envio do formulário:", err);
        }
    }, [pageSlug]);

    const trackWhatsappClick = useCallback(async () => {
        try {
            const pageRef = doc(db, "landingPages", pageSlug);
            await updateDoc(pageRef, { whatsappClicks: increment(1) });
        } catch (err) {
            console.error("Erro ao rastrear clique no WhatsApp:", err);
        }
    }, [pageSlug]);

    useEffect(() => {
        window.platform_trackFormSubmission = trackFormSubmission;
        window.platform_trackWhatsappClick = trackWhatsappClick;

        const injectScripts = async () => {
            if (!htmlContent) {
                 setError("Conteúdo da página não fornecido.");
                 return;
            }

            try {
                const settingsRef = doc(db, "settings", "integrations");
                const settingsSnap = await getDoc(settingsRef);
                
                let html = htmlContent;
                const settings = settingsSnap.exists() ? settingsSnap.data() : {};

                if (settings.facebookPixelId) {
                    const pixelScript = `
                        <script>
                            !function(f,b,e,v,n,t,s)
                            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                            n.queue=[];t=b.createElement(e);t.async=!0;
                            t.src=v;s=b.getElementsByTagName(e)[0];
                            s.parentNode.insertBefore(t,s)}(window, document,'script',
                            'https://connect.facebook.net/en_US/fbevents.js');
                            fbq('init', '${settings.facebookPixelId}');
                            fbq('track', 'PageView');
                        </script>
                    `;
                    html = html.replace('</head>', `${pixelScript}</head>`);
                }

                const trackingScript = `
                    <script>
                        document.addEventListener('DOMContentLoaded', function() {
                            const form = document.getElementById('lead-form');
                            if (form) {
                                form.addEventListener('submit', function(e) {
                                    e.preventDefault();
                                    const formData = {};
                                    new FormData(form).forEach((value, key) => {
                                        formData[key] = value;
                                    });
                                    
                                    window.platform_trackFormSubmission(formData);
                                    if (window.fbq) { window.fbq('track', 'Lead'); }

                                    const successMsg = document.getElementById('success-message');
                                    if (successMsg) {
                                       form.style.display = 'none';
                                       successMsg.style.display = 'block';
                                    }
                                });
                            }
                            const whatsappButtons = document.querySelectorAll('a[href*="wa.me"], .whatsapp-button');
                            whatsappButtons.forEach(button => {
                                button.addEventListener('click', function() {
                                    window.platform_trackWhatsappClick();
                                });
                            });
                        });
                    </script>
                `;
                html = html.replace('</body>', `${trackingScript}</body>`);
                setPageWithScripts(html);

            } catch (err) {
                console.error("Erro ao injetar scripts:", err);
                setError("Ocorreu um erro ao preparar a página.");
            }
        };

        injectScripts();
        
        return () => {
            delete window.platform_trackFormSubmission;
            delete window.platform_trackWhatsappClick;
        }

    }, [htmlContent, pageSlug, trackFormSubmission, trackWhatsappClick]);

    if (error) {
        return <div className="flex items-center justify-center h-screen text-red-500 font-semibold">{error}</div>;
    }

    if (!pageWithScripts) {
        return <div className="flex items-center justify-center h-screen">Carregando página...</div>;
    }

    return <iframe srcDoc={pageWithScripts} style={{ width: '100%', height: '100vh', border: 'none' }} title={pageSlug || 'Landing Page'} />;
};


/**
 * Componente Principal (App)
 * Responsabilidade: Controlar o roteamento e o estado de autenticação.
 */
export default function App() {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [route, setRoute] = useState(window.location.pathname);
    const [dbPageContent, setDbPageContent] = useState(null);
    
    // Efeito para injetar a Google Tag na página principal
    useEffect(() => {
        // Verifica se a tag já existe para não duplicar
        if (document.getElementById('google-tag-manager-script')) {
            return;
        }

        const gtmScript = document.createElement('script');
        gtmScript.id = 'google-tag-manager-script';
        gtmScript.async = true;
        gtmScript.src = `https://www.googletagmanager.com/gtag/js?id=AW-17510670342`;
        document.head.appendChild(gtmScript);

        const gtagScript = document.createElement('script');
        gtagScript.id = 'google-tag-config-script';
        gtagScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-17510670342');
        `;
        document.head.appendChild(gtagScript);

    }, []);


    // Função para popular o banco com dados iniciais (se estiver vazio)
    const seedDatabase = async () => {
        const pagesCollection = collection(db, "landingPages");
        const pagesSnapshot = await getDocs(pagesCollection);
        if (pagesSnapshot.empty) {
            console.log("Banco de dados vazio. Semeando com dados de exemplo...");
            try {
                await setDoc(doc(db, "landingPages", "guia-bpc-loas-exemplo"), {
                    name: "Guia BPC/LOAS (Exemplo)",
                    htmlContent: sampleHtmlContent,
                    views: 0,
                    formSubmissions: 0,
                    whatsappClicks: 0,
                    createdAt: serverTimestamp()
                });
                await setDoc(doc(db, "settings", "integrations"), {
                    facebookPixelId: "",
                    webhookUrl: ""
                });
                console.log("Dados de exemplo criados com sucesso.");
            } catch (error) {
                console.error("Erro ao semear banco de dados:", error);
            }
        }
    };
    
    // Gerencia o estado de autenticação do usuário
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setIsLoading(false);
            if(currentUser){
                seedDatabase();
            }
        });
        return unsubscribe;
    }, []);

    // Gerencia as rotas da URL
    useEffect(() => {
        const handlePopState = () => setRoute(window.location.pathname);
        window.addEventListener('popstate', handlePopState);
        
        const fetchPageForRoute = async () => {
            const path = window.location.pathname;
            if (path !== '/' && !path.startsWith('/admin')) {
                const slug = path.substring(1);
                const pageRef = doc(db, "landingPages", slug);
                try {
                    const pageSnap = await getDoc(pageRef);
                    if(pageSnap.exists()){
                        await updateDoc(pageRef, { views: increment(1) });
                        setDbPageContent(pageSnap.data().htmlContent);
                    } else {
                        setDbPageContent(null); // Página não encontrada
                    }
                } catch(e) {
                    console.error("Erro ao buscar página do DB:", e);
                    setDbPageContent(null);
                }
            }
        };

        fetchPageForRoute();

        return () => window.removeEventListener('popstate', handlePopState);
    }, [route]); 

     const handleLogout = async () => {
        await signOut(auth);
        window.history.pushState({}, '', '/admin');
        setRoute('/admin');
    };
    
    if (isLoading) {
        return <div className="flex items-center justify-center h-screen">Carregando...</div>;
    }

    // --- LÓGICA DE ROTEAMENTO ---
    const path = window.location.pathname;

    if (path.startsWith('/admin')) {
        if (user) {
            return <AdminPanel onLogout={handleLogout} />;
        }
        return <LoginPage />;
    }
    
    if (path === '/') {
        return <PublicPageRenderer htmlContent={homePageHtml} pageSlug="home" />;
    }

    if (dbPageContent) {
        const slug = path.substring(1);
        return <PublicPageRenderer htmlContent={dbPageContent} pageSlug={slug} />;
    }
    
    // Página não encontrada para rotas públicas que não estão no DB
    return (
         <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
            <h1 className="text-4xl font-bold text-gray-800">404</h1>
            <p className="text-lg text-gray-600">Página não encontrada.</p>
        </div>
    );
}

